module.exports = __webpack_public_path__ + "fonts/OpenSans-Italic.c27ebc19.woff2";